(function () {
    'use strict';

    angular.module('PWAPoCApp')
        .directive('toaster', function () {
            return {
                restrict: 'E',
                template: `
                    <div class="custom-toaster">
                        <div ng-repeat="toast in toasts" class="toast {{toast.type}}">
                            {{toast.message}}
                        </div>
                    </div>
                `,
                link: function (scope) {
                    scope.toasts = scope.$root.toasts;
                }
            };
        });
})();